import { render, staticRenderFns } from "./VietQrImage.vue?vue&type=template&id=a28ca6aa&"
import script from "./VietQrImage.vue?vue&type=script&lang=js&"
export * from "./VietQrImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports